import { Link } from "react-router-dom";
import StickyNavbar from "../navbar";
import { motion } from "framer-motion";
import QuizPopup from "./QuizPopup";
import React, { useState } from "react";

const ChapterTwoTwo = () => {
   const [showQuiz, setShowQuiz] = useState(false);
  
    const handleQuizComplete = (answers) => {
      console.log("User answers:", answers);
      // You can process the answers here
    };
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const hoverEffect = {
    whileHover: { scale: 1.05 },
    transition: { duration: 0.3 },
  };

  return (
    <div>
      <StickyNavbar />

      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 lg:text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div className="space-y-3 lg:text-left" variants={fadeIn}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center">
            Group Discussion
          </h2>
          <p>
            To help you understand the importance of research ethics, think
            about and discuss in a group the following questions:
          </p>
          <motion.ul
            className="list-decimal list-inside text-left space-y-3"
            variants={fadeIn}
          >
            <motion.li variants={fadeIn}>
              Which key principles stood out to you, and why?
            </motion.li>
            <motion.li variants={fadeIn}>
              How would you ensure that potential participants for your study
              are respected and protected?
            </motion.li>
            <motion.li variants={fadeIn}>
              What steps might you take to make sure you get informed consent
              from participants taking part in your research?
            </motion.li>
          </motion.ul>
        </motion.div>
          <motion.div
                            className=" rounded-lg p-4"
                            whileHover={{ scale: 1.05 }}
                            transition={{ duration: 0.3 }}
                          >
                            <div className="flex justify-center">
                              <img
                                src="/images/discuss.svg"
                                alt="Community health worker engaging with locals"
                                className="w-full max-w-md rounded-md"
                              />
                            </div>
                           
                          </motion.div>

        {/* <motion.div className="space-y-3" variants={fadeIn}>
          <h2 className="text-xl font-bold mb-2 my-4 text-[#005FFF] mt-5">
            Please record the details of your discussion in this box:
          </h2>
          <motion.ul
            className="list-disc list-inside space-y-3"
            variants={fadeIn}
          >
            <motion.li variants={fadeIn}>
              How many people attended the discussion? __________________
            </motion.li>
            <motion.li variants={fadeIn}>
              Who attended the discussion? __________________
            </motion.li>
            <motion.li variants={fadeIn}>
              What key things can you take away from this discussion, or what
              did you particularly agree on?__________________
            </motion.li>
            <motion.li variants={fadeIn}>Further reading: National ethics code</motion.li>
            <motion.li variants={fadeIn}>Group discussion in order to proceed to next section</motion.li>
            <motion.li variants={fadeIn}>
              The manual and app should include a text box where they can
              provide details about the discussion e.g Who attended? How many?
            </motion.li>
          </motion.ul>
          <p>
            Follow this link:{" "}
            <a
              href="https://about.citiprogram.org/courses/?fwp_search=ethics"
              className="text-blue-600"
            >
              'https://about.citiprogram.org/courses/?fwp_search=ethics'
            </a>
            to read more about research ethics
          </p>
        </motion.div> */}

        <div className="flex justify-between mt-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/SectionOne">
              <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </motion.div>
          <div className="flex justify-center ">
          <button
            onClick={() => setShowQuiz(true)}
        
            className="bg-white text-blue-800 border border-blue-800 px-3 py-2 rounded-lg "
          >
            Test Your Knowledge
          </button>
        </div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            
            <Link to="/chapter3">
              <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
      {showQuiz && (
        <QuizPopup
          onClose={() => setShowQuiz(false)}
          onComplete={handleQuizComplete}
        />
      )}
    </div>
  );
};

export default ChapterTwoTwo;
